import { createSlice } from '@reduxjs/toolkit'
import RolesService from './roles.service'
import { ROLES } from '../../utils/constants/actionTypes'
import createAsyncThunkMiddleware from '../../utils/helpers/createAsyncThunkMiddleware'
import extraReducersCommon from '../common/extraReducers'

/**
 * body - {...}
 */
export const createRole = createAsyncThunkMiddleware(
  ROLES.CREATE,
  RolesService.create,
)

/**
 * filter, limit, page
 */
export const getAllRoles = createAsyncThunkMiddleware(
  ROLES.GET_ALL,
  RolesService.getAll,
)

/**
 * roleId
 */
export const getRole = createAsyncThunkMiddleware(
  ROLES.GET,
  RolesService.getById,
)

/**
 * { roleId, body - {...}}
 */
export const updateRole = createAsyncThunkMiddleware(
  ROLES.UPDATE,
  RolesService.update,
)

/**
 * roleId
 */
export const removeRole = createAsyncThunkMiddleware(
  ROLES.REMOVE,
  RolesService.remove,
)

const initialState = {}

const rolesSlice = createSlice({
  name: 'roles',
  initialState,
  reducers: {},
  extraReducers: extraReducersCommon(
    createRole,
    updateRole,
    getAllRoles,
    removeRole,
  ),
})

export default rolesSlice.reducer
